let currentIndex = 0;

export const resetIndex = () => {
	currentIndex = 0;
};

function showCurrentBlock() {
	Array.from(document.getElementsByClassName('hint_popup')).forEach(
		(block, index) => {
			if (index === currentIndex) {
				block.classList.add('active');
				block.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
					inline: 'nearest',
				});
			} else {
				block.classList.remove('active');
			}
		}
	);
}

export const handleNextClick = () => {
	if (
		currentIndex <
		Array.from(document.getElementsByClassName('hint_popup')).length - 1
	) {
		currentIndex++;
		showCurrentBlock();
	}
};

export const handleBackClick = () => {
	if (currentIndex > 0) {
		currentIndex--;
		showCurrentBlock();
	}
};

export const handleCloseClick = (userData) => {
	userData.setCustomerUser({...userData.CustomerUser, "first_login":false})
	Array.from(document.getElementsByClassName('hint_popup')).forEach((block) =>
		block.classList.remove('active')
	);
	document.cookie = 'ostreon_onboarding_cookie=1';
};
